// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.searchResultsModal_paper__DmG9w {
  min-height: 320px;
}

.searchResultsModal_content__CCcw3 {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding-top: 1.25rem !important;
}

/* The field and its Help link. Their own tight gap, so the 1rem gap on
   .content stays between the search box and the results, not around the
   link. */
.searchResultsModal_searchRow__MzRJJ {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.3rem;
}

.searchResultsModal_results__2XEBD {
  flex: 1 1 auto;
  min-height: 220px;
  max-height: 55vh;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}

.searchResultsModal_section__H\\+VPL {
  display: flex;
  flex-direction: column;
}

.searchResultsModal_sectionHeader__qI1NG {
  display: flex;
  align-items: baseline;
  /* flex-start, not space-between: the count belongs next to its title, and
     "See all" is pushed right on its own via margin-left. */
  justify-content: flex-start;
  gap: 0.5rem;
  padding: 0 0.4rem 0.35rem;
  border-bottom: 1px solid var(--black10);
  position: sticky;
  top: 0;
  background: var(--white);
}

.searchResultsModal_sectionTitle__xVkFY {
  font-weight: 700;
  font-size: 0.78rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--black70);
}

.searchResultsModal_sectionCount__Qgo-e {
  font-size: 0.72rem;
  font-weight: 600;
  color: var(--black70);
  background: var(--black10);
  border-radius: 999px;
  padding: 0.05rem 0.55rem;
  min-width: 1.2rem;
  text-align: center;
}

.searchResultsModal_list__hGE7x {
  list-style: none;
  margin: 0;
  padding: 0.25rem 0 0;
  display: flex;
  flex-direction: column;
}

.searchResultsModal_row__VxvAl {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.5rem 0.4rem;
  border-radius: 6px;
  cursor: pointer;
}

.searchResultsModal_row__VxvAl:hover,
.searchResultsModal_rowFocused__89mb\\+ {
  background-color: var(--lightMain);
}

.searchResultsModal_thumb__\\+9MF3 {
  flex: 0 0 auto;
  width: 40px;
  height: 40px;
  border-radius: 4px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--black10);
}

.searchResultsModal_thumbImg__bD39h {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.searchResultsModal_thumbPlaceholderIcon__AQQB- {
  color: var(--iconGrey);
}

.searchResultsModal_rowText__OR3FV {
  min-width: 0;
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
}

.searchResultsModal_rowLabel__9tFRK {
  font-weight: 600;
  font-size: 0.9rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.searchResultsModal_rowSublabel__4xj\\+N {
  font-size: 0.78rem;
  color: var(--black70);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Product id + created date, right-aligned opposite the label/sublabel.
   flex: 0 0 auto plus nowrap so the label column (min-width: 0) is the one
   that gives way and ellipsises on a narrow modal - a truncated part name is
   still recognisable, half a date is not. */
.searchResultsModal_rowMeta__H-3sb {
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
  gap: 0.1rem;
  padding-left: 0.5rem;
  white-space: nowrap;
  text-align: right;
}

.searchResultsModal_rowProductId__jpk0m {
  font-size: 0.78rem;
  font-weight: 600;
  color: var(--black70);
}

.searchResultsModal_rowCreated__ALgPS {
  font-size: 0.72rem;
  color: var(--black70);
  font-variant-numeric: tabular-nums;
}

.searchResultsModal_emptyState__8USGW {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1 1 auto;
  padding: 3rem 1rem;
  color: var(--black70);
  font-weight: 600;
  text-align: center;
}

.searchResultsModal_skeletonList__muHxW {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.searchResultsModal_skeletonRow__ZpiKL {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.4rem;
}

.searchResultsModal_skeletonText__r1Whj {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

@media (max-width: 600px) {
  .searchResultsModal_results__2XEBD {
    max-height: none;
  }

  .searchResultsModal_row__VxvAl {
    padding: 0.65rem 0.4rem;
  }
}

/* Reset the button back to text - it sits inline in the section header and
   should read as a link, not a control. */
.searchResultsModal_seeAll__ZJQvw {
  margin-left: auto;
  border: none;
  background: none;
  padding: 0;
  font: inherit;
  font-size: 0.72rem;
  font-weight: 600;
  color: var(--primary, #e0a900);
  cursor: pointer;
  white-space: nowrap;
}

.searchResultsModal_seeAll__ZJQvw:hover,
.searchResultsModal_seeAll__ZJQvw:focus-visible {
  text-decoration: underline;
}
`, "",{"version":3,"sources":["webpack://./src/components/GlobalSearch/searchResultsModal.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,+BAA+B;AACjC;;AAEA;;UAEU;AACV;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB;4DAC0D;EAC1D,2BAA2B;EAC3B,WAAW;EACX,yBAAyB;EACzB,uCAAuC;EACvC,gBAAgB;EAChB,MAAM;EACN,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,0BAA0B;EAC1B,oBAAoB;EACpB,wBAAwB;EACxB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,oBAAoB;EACpB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;EAEE,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;;;4CAG4C;AAC5C;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;EACvB,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA;0CAC0C;AAC1C;EACE,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,8BAA8B;EAC9B,eAAe;EACf,mBAAmB;AACrB;;AAEA;;EAEE,0BAA0B;AAC5B","sourcesContent":[".paper {\n  min-height: 320px;\n}\n\n.content {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  padding-top: 1.25rem !important;\n}\n\n/* The field and its Help link. Their own tight gap, so the 1rem gap on\n   .content stays between the search box and the results, not around the\n   link. */\n.searchRow {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 0.3rem;\n}\n\n.results {\n  flex: 1 1 auto;\n  min-height: 220px;\n  max-height: 55vh;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 1.25rem;\n}\n\n.section {\n  display: flex;\n  flex-direction: column;\n}\n\n.sectionHeader {\n  display: flex;\n  align-items: baseline;\n  /* flex-start, not space-between: the count belongs next to its title, and\n     \"See all\" is pushed right on its own via margin-left. */\n  justify-content: flex-start;\n  gap: 0.5rem;\n  padding: 0 0.4rem 0.35rem;\n  border-bottom: 1px solid var(--black10);\n  position: sticky;\n  top: 0;\n  background: var(--white);\n}\n\n.sectionTitle {\n  font-weight: 700;\n  font-size: 0.78rem;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: var(--black70);\n}\n\n.sectionCount {\n  font-size: 0.72rem;\n  font-weight: 600;\n  color: var(--black70);\n  background: var(--black10);\n  border-radius: 999px;\n  padding: 0.05rem 0.55rem;\n  min-width: 1.2rem;\n  text-align: center;\n}\n\n.list {\n  list-style: none;\n  margin: 0;\n  padding: 0.25rem 0 0;\n  display: flex;\n  flex-direction: column;\n}\n\n.row {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 0.5rem 0.4rem;\n  border-radius: 6px;\n  cursor: pointer;\n}\n\n.row:hover,\n.rowFocused {\n  background-color: var(--lightMain);\n}\n\n.thumb {\n  flex: 0 0 auto;\n  width: 40px;\n  height: 40px;\n  border-radius: 4px;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--black10);\n}\n\n.thumbImg {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n\n.thumbPlaceholderIcon {\n  color: var(--iconGrey);\n}\n\n.rowText {\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  flex: 1 1 auto;\n}\n\n.rowLabel {\n  font-weight: 600;\n  font-size: 0.9rem;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.rowSublabel {\n  font-size: 0.78rem;\n  color: var(--black70);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* Product id + created date, right-aligned opposite the label/sublabel.\n   flex: 0 0 auto plus nowrap so the label column (min-width: 0) is the one\n   that gives way and ellipsises on a narrow modal - a truncated part name is\n   still recognisable, half a date is not. */\n.rowMeta {\n  flex: 0 0 auto;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  justify-content: center;\n  gap: 0.1rem;\n  padding-left: 0.5rem;\n  white-space: nowrap;\n  text-align: right;\n}\n\n.rowProductId {\n  font-size: 0.78rem;\n  font-weight: 600;\n  color: var(--black70);\n}\n\n.rowCreated {\n  font-size: 0.72rem;\n  color: var(--black70);\n  font-variant-numeric: tabular-nums;\n}\n\n.emptyState {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex: 1 1 auto;\n  padding: 3rem 1rem;\n  color: var(--black70);\n  font-weight: 600;\n  text-align: center;\n}\n\n.skeletonList {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.skeletonRow {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 0.4rem;\n}\n\n.skeletonText {\n  flex: 1 1 auto;\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n}\n\n@media (max-width: 600px) {\n  .results {\n    max-height: none;\n  }\n\n  .row {\n    padding: 0.65rem 0.4rem;\n  }\n}\n\n/* Reset the button back to text - it sits inline in the section header and\n   should read as a link, not a control. */\n.seeAll {\n  margin-left: auto;\n  border: none;\n  background: none;\n  padding: 0;\n  font: inherit;\n  font-size: 0.72rem;\n  font-weight: 600;\n  color: var(--primary, #e0a900);\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.seeAll:hover,\n.seeAll:focus-visible {\n  text-decoration: underline;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"paper": `searchResultsModal_paper__DmG9w`,
	"content": `searchResultsModal_content__CCcw3`,
	"searchRow": `searchResultsModal_searchRow__MzRJJ`,
	"results": `searchResultsModal_results__2XEBD`,
	"section": `searchResultsModal_section__H+VPL`,
	"sectionHeader": `searchResultsModal_sectionHeader__qI1NG`,
	"sectionTitle": `searchResultsModal_sectionTitle__xVkFY`,
	"sectionCount": `searchResultsModal_sectionCount__Qgo-e`,
	"list": `searchResultsModal_list__hGE7x`,
	"row": `searchResultsModal_row__VxvAl`,
	"rowFocused": `searchResultsModal_rowFocused__89mb+`,
	"thumb": `searchResultsModal_thumb__+9MF3`,
	"thumbImg": `searchResultsModal_thumbImg__bD39h`,
	"thumbPlaceholderIcon": `searchResultsModal_thumbPlaceholderIcon__AQQB-`,
	"rowText": `searchResultsModal_rowText__OR3FV`,
	"rowLabel": `searchResultsModal_rowLabel__9tFRK`,
	"rowSublabel": `searchResultsModal_rowSublabel__4xj+N`,
	"rowMeta": `searchResultsModal_rowMeta__H-3sb`,
	"rowProductId": `searchResultsModal_rowProductId__jpk0m`,
	"rowCreated": `searchResultsModal_rowCreated__ALgPS`,
	"emptyState": `searchResultsModal_emptyState__8USGW`,
	"skeletonList": `searchResultsModal_skeletonList__muHxW`,
	"skeletonRow": `searchResultsModal_skeletonRow__ZpiKL`,
	"skeletonText": `searchResultsModal_skeletonText__r1Whj`,
	"seeAll": `searchResultsModal_seeAll__ZJQvw`
};
export default ___CSS_LOADER_EXPORT___;
